import React, {useContext} from 'react'
import {NullAsDefault} from 'views/Shared'
import {Avatar} from "antd";
import {renderIf, renderIfElse} from "../../../Shared";
import _ from "lodash"
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {FeastStates} from "../../appFieldTypes";
import {PrelatesOutlineSvg} from "../../../../components/Svgs/PrelatesPlaceholder";
import {SaintsFillSvg, SaintsOutlineSvg} from "../../../../components/Svgs/SaintsPlaceholder";
import useTranslate from "../../../../modules/local/useTranslate";
import {PiCrossFill} from "react-icons/pi";
import classNames from "classnames";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {Link} from "react-router-dom";
import {getType} from "../../../../apis/model/base";
import {formatDate} from "../../../../helpers/datetimeHelpers";
import dayjs from "dayjs";
import CRUD from "../../../Shared/enums/CRUD";
import {profileCategories} from "../consts/profileCategories";


export const renderProfile = ({history, isSm, translate: t, renderContextMenu = NullAsDefault, handleAction = NullAsDefault, profileCode} = {}) => (item, index) => {
    const {
        name, common_name,
        photo,
        date_of_birth,
        date_of_death,
        feast_day, patron_saint_feast_day,
        feast_state,
        position_title,
        year_of_birth,
        year_of_death,
        is_martyr,
        is_holy_doctor,
        is_lay_person,
        is_musician,
        is_philosopher,
        is_prelate,
        is_saint,
        is_scientist,
        is_theologian,
    } = item ?? {}

    const profileFlags = {
        is_martyr,
        is_holy_doctor,
        is_saint,
        is_prelate,
        is_philosopher,
        is_theologian,
        is_musician,
        is_lay_person,
        is_scientist,
    };

    const DateOfDeath = () => (
        <div className="flex items-center gap-x-1 text-xs text-color-400 italic leading-tight tracking-wide">
            {'('}
            <span className="font-medium text-color-300">
                            {renderIfElse(
                                date_of_birth,
                                formatDate(date_of_birth, 'DD/MM/YYYY'),
                                year_of_birth > 0 ? year_of_birth : ' ... '
                            )}
                        </span>
            <span className="mx-1">{' - '}</span>
            <span className="space-x-1 font-bold text-color-100">
                {renderIf(
                    _.some([date_of_death, year_of_death !== 0]),
                    <PiCrossFill size={10} className={classNames('mr-1', is_martyr ? 'text-primary-600' : 'text-color-000')}/>
                )}
                {renderIfElse(
                    date_of_death,
                    formatDate(date_of_death, 'DD/MM/YYYY'),
                    year_of_death > 0 ? year_of_death : ' ... '
                )}
            </span>
            {')'}
        </div>
    )

    const labels = profileCategories
        .filter((e) => profileFlags[e.value] === 1)
        .map((e) => e.label);

    return (
        <div className="flex background border border-color-50 shadow-md hover:scale-2xs rounded-xl custom-item-render relative">
            <Avatar
                onClick={() => {handleAction(CRUD.READ, item)}}
                src={photo}
                style={{ width: isSm ? 80 : 120, height: '100%' }}
                icon={ <SaintsFillSvg size={isSm ? 50 : 70} style={{color: '#dddddd'}}/>}
                className="flex flex-center background-200 rounded-l-xl rounded-r-0 cursor-pointer"
            />
            <div className="p-3 flex flex-col flex-1">
                <div
                    onClick={() => {handleAction(CRUD.READ, item)}}
                    className="mr-6 font-bold md:text-base text-color-000 mb-1 max-lines-1 leading-snug cursor-pointer">
                    {renderIfElse(
                        !!common_name && (name !== common_name),
                        <>
                            <span>{common_name}</span>
                            <span className="ml-2 font-medium text-sm text-primary-400 italic">{`(${name})`}</span>
                        </>,
                        <span>{name}</span>
                    )}
                </div>
                <div className="flex flex-col gap-2">
                    <DateOfDeath />
                    <div className="flex items-center gap-x-6">
                        {renderIf(
                            feast_state,
                            <span className="space-x-1 font-semibold text-xs text-blue-500 italic tracking-wide">
                                {t(_.find(FeastStates, {value: feast_state})?.label)}
                                {renderIf(feast_day,`  -  ( ${dayjs(feast_day, 'DD/MM').format('DD/MM')} )`)}
                            </span>
                        )}
                        {renderIf(
                            position_title,
                            <span
                                style={{ padding: '3px 8px' }}
                                className="font-medium text-xs text-blue-500 bg-blue-100 rounded-md italic leading-snug tracking-wide">
                                {t(position_title || '')}
                            </span>
                        )}

                    </div>
                    <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                        {labels.map((e, i) => (
                            <span
                                key={i} style={{ padding: '2px 8px', fontSize: 11 }}
                                className="bg-primary-50 rounded font-bold text-primary-600">
                                {t(e)}
                            </span>
                        ))}
                    </div>
                    <span
                        style={{ position: 'absolute', bottom: 5, right: 5 }}
                        onClick={() => { history.push(getLinkToDetail(item)) }}
                        className="text-xs text-color-500 hover:text-color-100 italic no-underline tracking-wide cursor-pointer">
                        {`${t('view detail')}...`}
                    </span>
                </div>
            </div>
            {_.isFunction(renderContextMenu) && (
                <div className="absolute right-5 top-5 contextIcon">
                    {renderContextMenu(item)}
                </div>
            )}
        </div>
    )
}

export const ProfileCompact = ({item}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const {
        name,
        photo,
        feast_day, patron_saint_feast_day,
        feast_state,
        is_martyr,
        is_holy_doctor,
        position_title
    } = item ?? {}

    return (
        <React.Fragment>
            <div className="flex items-center gap-3 custom-render-border rounded-lg relative">
                <Avatar
                    size={60}
                    src={photo}
                    icon={renderIfElse(
                        feast_state,
                        <SaintsOutlineSvg size={30} className="text-color-500"/>,
                        <PrelatesOutlineSvg size={30} className="text-color-500"/>
                    )}
                    className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                />
                <div className="flex flex-col flex-1 py-1">
                    <Link
                        to={getLinkToDetail(item)}
                        target="_blank"
                        className="font-bold text-base text-color-000 leading-snug no-underline mb-1">
                        {name}
                    </Link>
                    <div className="flex items-center gap-3">
                        {renderIf(
                            is_martyr === 1,
                            <span style={{height: 20, fontSize: 11, padding: '0 10px'}}
                                  className="flex flex-center font-medium bg-primary-50 text-primary-600 rounded-xs tracking-wide leading-tight">
                                {t('martyr')}
                            </span>
                        )}
                        {renderIf(
                            is_holy_doctor === 1,
                            <span style={{height: 20, fontSize: 11, padding: '0 10px'}}
                                  className="flex flex-center font-medium bg-primary-50 text-primary-600 rounded-xs tracking-wide leading-tight">
                                {t('doctor of church')}
                            </span>
                        )}
                        {renderIf(
                            position_title,
                            <span style={{height: 20, fontSize: 11, padding: '0 10px'}}
                                  className="flex flex-center font-medium bg-blue-100 text-blue-600 rounded-xs tracking-wide leading-tight">
                              {t(position_title || '')}
                          </span>
                        )}
                        {renderIf(
                            feast_state,
                            <span style={{height: 20, fontSize: 11, padding: '0 10px'}}
                                  className="flex flex-center font-medium bg-blue-100 text-blue-600 rounded-xs tracking-wide leading-tight">
                              {t(_.find(FeastStates, {value: feast_state})?.label)}
                          </span>
                        )}
                    </div>
                </div>
                <span
                    style={{height: 20, fontSize: 10, padding: '0 10px'}}
                    className="absolute right-5 flex flex-center bg-orange-50 rounded-full font-medium text-orange-500 italic leading-tight">
                      {t(getType(item))}
                  </span>
            </div>
        </React.Fragment>
    )
}



